import { useState, useEffect } from 'react'
import classNames from 'classnames'

import Checkbox from '@components/Checkbox'
import Button from '@components/Button'
import Textfield from '@components/Textfield'

import styles from '../styles/Subscribe.module.scss'

const SubscribeForm = ({
    pending,
    subscribed,
    defaults,
    requireConsent,
    subscribeNews,
    translate,
    consentLabel,
    subscribeMessage,
}) => {
    const isLoading = pending === true
    const isSubscribed = subscribed === true
    const isConsentRequired = requireConsent || (requireConsent === undefined && defaults.requireConsent)
    const [email, setEmail] = useState('')

    const updateEmailInput = event => {
        const { value } = event.target
        return setEmail(value)
    }

    const submit = event => {
        event.preventDefault()
        subscribeNews(email)
    }

    useEffect(() => {
        subscribed && setEmail('')
    }, [subscribed])

    return (
        <>
            <form onSubmit={submit} className="mb-sm-6">
                <fieldset disabled={isLoading}>
                    <div className="row no-gutters justify-content-center align-items-center mt-3">
                        <div className="col-12 mb-2 mb-sm-0 col-sm-8">
                            <Textfield
                                value={email}
                                onChange={updateEmailInput}
                                name="email"
                                type="email"
                                required
                                label={translate('input.placeholder.email')}
                            />
                        </div>
                        <div className="col-12 col-sm-4">
                            <Button
                                isLoading={isLoading}
                                disabled={isLoading}
                                block
                                size="large"
                                className={classNames('ml-sm-1', 'h3-mob', styles.subscribeButton)}
                                btnStyle="secondary">
                                <T>sign.up.news.btn.label</T>
                            </Button>
                        </div>
                    </div>
                    {isConsentRequired && (
                        <div className="row no-gutters justify-content-center">
                            <div className="col-12 mt-3">
                                <Checkbox
                                    className={styles.subscribe__checkbox}
                                    label={consentLabel || defaults.consentLabel}
                                    required
                                />
                            </div>
                        </div>
                    )}
                </fieldset>

                {isSubscribed && (
                    <div className={classNames(styles.subscribe__message, 'text-center')}>
                        <strong>
                            <T>{subscribeMessage}</T>
                        </strong>
                    </div>
                )}
            </form>
        </>
    )
}

export default SubscribeForm
